<ng-template #yearPortionPickerContent>
  <rms-year-portion-picker-values [yearsList]="yearsList"
                                  [initialValue]="initialValue"
                                  (yearSelected)="onYearSelected($event)"
                                  (onQuarterSelected)="quarterSelected($event)">
  </rms-year-portion-picker-values>
  <hr>
  <div class="text-right">
    <button class="btn btn-default pl-2 pr-2" (click)="p.close()">{{"GENERICS.CANCEL" | translate}}</button>
    <button class="btn btn-default pl-2 pr-2" (click)="resetDateRange(true); p.close()">Clear</button>
    <button class="btn btn-teal pl-2 pr-2" [disabled]="invalidDateRange" (click)="setDateRange(); p.close()">{{"GENERICS.OK" | translate}}</button>
  </div>
</ng-template>
<div class="fake-input" [container]="'body'" [ngbPopover]="yearPortionPickerContent" [placement]="position ? position : 'bottom'" [autoClose]="false"
     #p="ngbPopover">
  <span class="placeholder" *ngIf="isEmpty">{{placeholder | translate}}</span>
  <i class="fa fa-calendar field-icon" *ngIf="isEmpty"></i>
  <span *ngIf="!isEmpty">{{startDate[0] + (displayValueYear.length > 0 ? displayValueYear : startDate[1])}}</span>
</div>
